import { tsValidateString, tsValidateUniqueId, tsValidateValue, tsValidator_arrayOfUniqueIds } from '@nu-art/ts-common';
import { ResourceTypes } from './types.js';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    type: tsValidateValue([...ResourceTypes]),
    tagId: tsValidateUniqueId,
    variableProperties: tsValidator_arrayOfUniqueIds,
    tagsProperties: tsValidator_arrayOfUniqueIds
};
const Validator_GeneratedProps = {};
export const DBDef_Resource = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: [],
    versions: ['1.0.0'],
    dbKey: 'resources',
    entityName: 'Resource',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'resource'
    },
    backend: {
        name: 'resources'
    },
    dependencies: {
        tagId: {
            dbKey: 'tags',
            fieldType: 'string'
        },
        variableProperties: {
            dbKey: 'variables',
            fieldType: 'string[]'
        },
        tagsProperties: {
            dbKey: 'tags',
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map